module.exports = __webpack_public_path__ + "img/pic_no information@2x.2e9a00f1.png";